var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEmpty, prune } from '../../utils';
var getNetworkMetrics = function () {
    var connection = navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection ||
        navigator.msConnection ||
        navigator.oConnection;
    return {
        downlink: connection === null || connection === void 0 ? void 0 : connection.downlink,
        downlinkMax: connection === null || connection === void 0 ? void 0 : connection.downlinkMax,
        effectiveType: connection === null || connection === void 0 ? void 0 : connection.effectiveType,
        rtt: connection === null || connection === void 0 ? void 0 : connection.rtt,
        saveData: connection === null || connection === void 0 ? void 0 : connection.saveData,
        type: connection === null || connection === void 0 ? void 0 : connection.type,
    };
};
var MetricCalc = /** @class */ (function () {
    function MetricCalc(appName) {
        var _this = this;
        this.init = function () {
            _this.metric = {
                to: window.location.pathname,
                startTime: Date.now(),
                is_page_load: true,
            };
            return _this;
        };
        this.getPerformanceData = function () {
            if (!isEmpty(_this.metric)) {
                var timeTaken = Date.now() - _this.metric.startTime;
                var performanceData = __assign(__assign({}, _this.scope), { isInBackground: document.hidden, page_url: _this.metric.to, perceived_page_load_time: timeTaken, is_page_load: _this.metric.is_page_load || false, network: getNetworkMetrics() });
                _this.resetMetric();
                return performanceData;
            }
        };
        this.resetMetric = function () {
            _this.metric = {};
        };
        this.appTransitionStart = function (toLocation, fromLocation) {
            if (toLocation === void 0) { toLocation = {}; }
            if (fromLocation === void 0) { fromLocation = {}; }
            _this.resetMetric();
            _this.metric = prune({
                to: toLocation.pathname,
                from: fromLocation.pathname,
                startTime: Date.now(),
            });
        };
        this.addDataToScope = function (data) {
            _this.scope = __assign(__assign({}, _this.scope), data);
        };
        // this.options = options;
        this.appName = appName;
        this.metric = {};
        this.scope = {};
        this.performance = window.performance;
        return this;
    }
    return MetricCalc;
}());
export default MetricCalc;
//# sourceMappingURL=MetricCalc.js.map